import {CreateSlice} from 'base'
import {addAuthorizationHeader} from 'base/api'
import {Session} from '.'

export interface AuthSlice {
  session: Session
  setSession: SetSession
}

export type SetSession = (session: Session) => void

const getInitalSession = (): Session => {
  const storageSession = localStorage.getItem('session')
  if (!storageSession) return null
  const parsedSession = JSON.parse(storageSession)
  addAuthorizationHeader(parsedSession)
  return parsedSession
}

const createAuthSlice: CreateSlice<AuthSlice> = (set) => ({
  session: getInitalSession(),
  setSession: (session) => set(() => ({session})),
})

export default createAuthSlice
